import Modal from "react-bootstrap/Modal";
import ReplyIcon from "@mui/icons-material/Reply";
import ShareModel from "../../components/Sharemodel/index";
import { useState } from "react";
import QRCode from 'qrcode.react';
import ShareOption from "../../components/Shareoption";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const Qrmodal = (props) => {
  const [showmodal, setshowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const location = useLocation();
  const { name } = useSelector((state) => state.user);

  const closemodal = () => {
    setshowmodal(false);
  };

  const handleCloseshare = () => {
    setShowshare(false);
    setshowmodal(true);
  };

  const handleShowshare = () => {
    setShowshare(true);
  };

  const baseUrl = process.env.REACT_APP_URL || window.location.origin;
  
  const getQrUrl = () => {
    let path = location.pathname;

    if (path === "/user-profile" || path === "/marketing-profile") {
      return `/other-profile/${name?._id}`;
    }
    
    // For shop profiles or viewing other user's profile, location.pathname is already the correct public link
    if (props.id && !path.includes(props.id)) {
      path = `/other-profile/${props.id}`;
    }

    // Replace MongoDB _id with human-readable shopid if available
    if (props.readableId && props.id && path.includes(props.id)) {
      path = path.replace(props.id, props.readableId);
    }

    return path;
  };

  const sharePath = getQrUrl();
  
  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={closemodal}
        handleShowshare={handleShowshare}
        shareurl={sharePath}
      />
      <Modal
        size="sm"
        show={props.show}
        onHide={props.handleClosemodal}
        aria-labelledby="example-modal-sizes-title-sm"
        centered
      >
        <Modal.Header
          className="p-3"
          closeButton
          style={{ backgroundColor: "#0353A4" }}
        >
          <Modal.Title
            id="example-modal-sizes-title-sm"
            style={{ color: "white", fontSize: "13px", paddingleft: "9px" }}
          >
            {location.pathname === "/user-profile" ? 'Profile QR Code' : 'Shop QR Code'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <div className="d-flex flex-column">
            <div
              style={{
                height: "auto",
                margin: "0 auto",
                maxWidth: 200,
                width: "100%",
              }}
            >

              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={`${baseUrl}${sharePath}`}
                viewBox={`0 0 256 256`} />
            </div>

            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                className="btn d-flex pt-0 pb-0 ps-1 pe-1"
                style={{
                  backgroundColor: "#0353A4",
                  color: "white",
                }}
                onClick={() => {
                  props.handleClosemodal(); // First close QR Modal
                  setshowmodal(true);       // Then open Share Modal
                }}
              >
                Share

                <ReplyIcon
                  style={{
                    transform: "rotateY(180deg)",
                    fontSize: "revert-layer",
                    color: "white",
                  }}
                />
              </button>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Qrmodal;
